var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckedLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#067BC2",
    rx: 2.444
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.688 13.854l7.866-7.668a1.048 1.048 0 0 1 1.463 1.5L9.42 16.069a1.048 1.048 0 0 1-1.463 0l-3.974-3.875a1.048 1.048 0 0 1 1.463-1.5l3.242 3.161z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckedLarge);
export default __webpack_public_path__ + "static/media/icon_checked_large.d3aa655e97f2ad43920a281ebdbf761c.svg";
export { ForwardRef as ReactComponent };